/* =============================================
   OTW APPAREL — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {
  var shopifyRoot =
    window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  function buildShopifyUrl(path) {
    return shopifyRoot + path.replace(/^\//, '');
  }

  /* ── ADD TO CART (AJAX CARDS) ─────────────── */
  document.querySelectorAll('.product-card-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submit = form.querySelector('.product-atc');
      if (!submit) return;

      submit.textContent = 'Adding...';
      submit.disabled = true;

      fetch(buildShopifyUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        submit.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(function () {
          submit.textContent = 'Add to Cart';
          submit.disabled = false;
        }, 1800);
      })
      .catch(function () {
        submit.textContent = 'Error — Try Again';
        submit.disabled = false;
      });
    });
  });

  /* ── LEGACY ADD TO CART BUTTONS ───────────── */
  document.querySelectorAll('.product-atc[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.productId;
      if (!variantId) return;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch(buildShopifyUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error — Try Again';
        btn.disabled = false;
      });
    });
  });

  /* ── CART COUNT ───────────────────────────── */
  function updateCartCount() {
    fetch(buildShopifyUrl('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      });
  }

  /* ── PRODUCT VARIANT UI ───────────────────── */
  document.querySelectorAll('.product-variant-select').forEach(function (select) {
    var form = select.closest('.product-form');
    if (!form) return;

    var submit = form.querySelector('.product-submit');
    var price = document.querySelector('[data-product-price]');
    var compare = document.querySelector('[data-product-compare]');

    function syncVariant() {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (price && option.dataset.price) {
        price.textContent = option.dataset.price;
      }

      if (compare) {
        if (option.dataset.compare) {
          compare.textContent = option.dataset.compare;
          compare.classList.remove('visually-hidden');
        } else {
          compare.textContent = '';
          compare.classList.add('visually-hidden');
        }
      }

      if (submit) {
        var isAvailable = option.dataset.available === 'true';
        submit.disabled = !isAvailable;
        submit.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
      }
    }

    select.addEventListener('change', syncVariant);
    syncVariant();
  });

  /* ── SMOOTH ANCHOR SCROLL ─────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
